import React from "react";
import SkyLight from "react-skylight";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "underscore";
import moment from "moment";  
class ClaimLog extends React.Component {
  constructor(props) {
    super(props);
    this.state = { claim: null };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.logRowData !== this.props.logRowData) {
      this.simpleDialog.show();

      this.setState({
        claim: nextProps.logRowData
      });
    }
  }
  render() {
    return (
      <div>
        <SkyLight
          dialogStyles={myBigGreenDialog}
          hideOnOverlayClicked
          ref={ref => (this.simpleDialog = ref)}
        >
          <p className="modal-header-title">Claim History</p>
          <div>
            <div className="claim-header">
              <p className="claim-log-date">Date</p>
              <p className="claim-log-status">Status</p>
              <p className="claim-log-entity">Entity</p>
              <p className="claim-log-msg">Message</p>
            </div>
            <div className="claim-logs">
            {this.renderLogItem()}

            </div>
          </div>
        </SkyLight>
      </div>
    );
  }

  renderLogItem = () => {
    const claim = this.state.claim;
    //const selectedClaim = this.props.selected_batch_claims;

    //let logs = [];
    if (claim !== null) {
      // _.each(selectedClaim, claimData => {
      //   if (claim.remote_claimid === claimData.remote_claimid) {
      //     logs = claimData.claimLog.logs;
      //   }
      // });

      //TODO: null check for claim.claimlog.logs
      if (!_.isEmpty(claim.claimLog)) {
        return _.map(claim.claimLog.logs, (log,index) => {
          return (
            <div className="claim-log" key={index}>
              <p className="claim-log-date">
                {moment(log.timestamp).format("MMMM Do YYYY h:mm:ss a")}
              </p>
              <p className="claim-log-status">{log.message.status}</p>
              <p className="claim-log-entity">{(log.entity === "CLAIM.MD" ? "Kinetik" : log.entity)}</p>
              <p className="claim-log-msg">{log.message.message}</p>
            </div>
          );
        });
      }
      else {
        return ( 
          <div>There are no logs for this claim!</div>
        )
      }
 
    }
  }
}
var myBigGreenDialog = {
  backgroundColor: "#fff",
  color: "#00000",
  width: "50%",
  borderRadius: "10px",
  overflow: "hidden"
};
const mapStateToProps = state => {
  return {
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ClaimLog);




// WEBPACK FOOTER //
// ./src/app/common/claim_log/ClaimLog.js